import { useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "./WhatsAppFloat";
import { NavigationProgress } from "./NavigationProgress";
import { GlobalSearch } from "@/components/GlobalSearch";
import { CompareBar } from "@/components/catalog/CompareBar";
import { ExitIntentPopup } from "@/components/home/ExitIntentPopup";
import GoogleMerchantBadge from "@/components/GoogleMerchantBadge";

export function Layout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (document.getElementById("schema-organization")) return;

    const schema = {
      "@context": "https://schema.org",
      "@type": ["WholesaleStore", "Organization"],
      name: "Atacado Óptico",
      url: "https://www.atacadooptico.com.br",
      logo: "https://www.atacadooptico.com.br/logo.png",
      email: "atendimento@atacadooptico.com.br",
      telephone: "+55-31-98501-5555",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Av. Afonso Pena, 726, Sala 800",
        addressLocality: "Belo Horizonte",
        addressRegion: "MG",
        postalCode: "30130-902",
        addressCountry: "BR",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: -19.9176,
        longitude: -43.9345,
      },
      areaServed: { "@type": "Country", name: "Brasil" },
      priceRange: "$$",
      sameAs: [
        "https://www.instagram.com/atacadooptico",
        "https://www.linkedin.com/company/atacado-optico",
      ],
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "sales",
        availableLanguage: "Portuguese",
        areaServed: "BR",
      },
    };

    const el = document.createElement("script");
    el.id = "schema-organization";
    el.type = "application/ld+json";
    el.textContent = JSON.stringify(schema);
    document.head.appendChild(el);
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <NavigationProgress />
      <Header />
      <main id="main-content" className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFloat />
      <ExitIntentPopup />
      <GlobalSearch />
      <CompareBar />
      <GoogleMerchantBadge />
    </div>
  );
}
